import { mapGetters, mapMutations } from "vuex";
import Common from "@/common";
import alertHelper from "@/helper/AlertHelper";

export const tetherMixin = {
  data() {
    return {
      showVideo: false,
      videoAddress: require("/src/assets/videos/payInstruction.mp4"),
      walletAddress: "",
      copyToClipboardResult: false,
      copyToClipboardFailed: false,
      expiresInFullText: "",
      expiresInMinutes: "",
      expiresInHours: "",
      expiresInSeconds: "",
      getTetherWalletResult: false,
      walletTimeRemain: 0,
      paymentId: "",
      querySecret: "",
      checkTransactionResultInterval: null,
      transactionResult: null,
    };
  },
  computed: {
    ...mapGetters([
      "getStepperPage",
      "getIsCompName",
      "getTetherCurrentPrice",
      "getVatanCurrentPrice",
      "getTronCurrentPrice",
      "getVersion",
      "getGlobalApiRequestPending",
      "getCallBackUrl",
    ]),
    getSiteIdCondition() {
      return Common.siteIdCondition();
    },
    getSiteIdFiveCondition() {
      return Common.siteIdFiveCondition;
    },
    getSiteRatesDisplayCondition() {
      return Common.siteShowRatesCondition();
    },
  },
  watch: {
    getStepperPage(value) {
      if (value === "pageTwo") {
        this.activateTimerEvent("TetherTimer");
      }
    },
  },
  methods: {
    ...mapMutations(["setStepperPage", "setIsCompName"]),
    goToCryptoGroup() {
      this.$router.go(-1);
      // this.$router.push(
      // `/crypto-group?id=${this.paymentId}&s=${this.querySecret}`
      // );
    },
    generateTetherWalletUrl(walletType) {
      switch (walletType) {
        case "trc20":
          return `payments/${this.paymentId}/tether-wallet`;
        case "bep20":
          return `payments/${this.paymentId}/tether-bep20-wallet`;
        case "erc20":
          return `payments/${this.paymentId}/tether-erc20-wallet`;
        default:
          return `payments/${this.paymentId}/tether-wallet`;
      }
    },
    getTetherWallet(walletType = "trc20") {
      alertHelper.loadingAlert();
      const requestUrl = this.generateTetherWalletUrl(walletType);
      this.$http.get(requestUrl).then(
        (result) => {
          this.walletAddress = result.data.data.wallet;
          this.calculateTimeDiff(result?.data?.data?.expires_at);
          this.getTetherWalletResult = true;
          this.setStepperPage("pageTwo");
          alertHelper.successAlert("", result.data.message, 1500);
          this.startCheckingTransactionResult();
        },
        (error) => {
          this.getTetherWalletResult = false;
          alertHelper.apiErrorAlert("", error.body.message);
        }
      );
    },

    async getTransactionResult() {
      const requestUrl = `payments/${this.paymentId}/check-status`;
      try {
        const result = await this.$http.get(requestUrl);
        this.transactionResult = result;
      } catch (error) {
        console.log(error.body.message);
        this.transactionResult = null;
      }
    },
    async startCheckingTransactionResult() {
      this.checkTransactionResultInterval = setInterval(async () => {
        await this.getTransactionResult();
        const result = this.transactionResult;
        const resData = result.body.data;
        if (resData) {
          const callBackUrl = resData.callback_url;
          if (resData.transaction.status === "SUCCESS") {
            clearInterval(this.checkTransactionResultInterval);
            alertHelper.successAlert("پرداخت موفق", "", 1500);
            const createdCallBack = Common.createCallback(
              callBackUrl,
              this.paymentId,
              1
            );
            window.location.href = createdCallBack;
          }
        }
      }, 10000);
    },
    cancelPayment() {
      let paymentId = this.$route.query.id;
      alertHelper.loadingAlert();
      const callBackUrl = this.getCallBackUrl;
      if (callBackUrl) {
        window.location.href = Common.createCallback(
          callBackUrl,
          this.paymentId,
          0
        );
      } else {
        this.$http.delete(`payments/${paymentId}`).then((result) => {
          window.location.href = Common.createCallback(
            result.data.data.callback_url,
            paymentId,
            0
          );
        });
      }
    },
    openVideoPlayer() {
      setTimeout(() => {
        this.showVideo = !this.showVideo;
      }, 50);
    },
    clickedOutSideOfVideo() {
      this.showVideo = !this.showVideo;
    },
    copyToClipboard() {
      let walletAddressToCopy = document.querySelector("#walletAddress");
      walletAddressToCopy.setAttribute("type", "text");
      walletAddressToCopy.select();
      // Error Handling If Copying was not Successful
      try {
        this.copyToClipboardResult = document.execCommand("copy");
        alertHelper.successAlert("", "آدرس ولت کپی شد");
      } catch (err) {
        this.copyToClipboardFailed = true;
        alertHelper.errorAlert("", "مشکل در کپی کردن آدرس ولت!!", 1000);
      }
    },

    // Calculating Time difference between Now and Expire_in sent from api
    calculateTimeDiff(expireAtFromApi) {
      let expireTimeIso =
        typeof expireAtFromApi !== "undefined" ? expireAtFromApi : "";
      let getNow = new Date();
      let expireTimeMilis = new Date(expireTimeIso).getTime();
      // timeDifference is in Mili Seconds!
      this.walletTimeRemain = expireTimeMilis - getNow;
    },
    timerExpiredAlert() {
      this.$swal({
        title: "توجه",
        text: "مدت زمان اعتبار آدرس کیف پول اختصاصی شما به پایان رسیده است!",
        icon: "danger",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        allowOutsideClick: false,
        preConfirm: () => {
          this.$router.push(
            `/tether?id=${this.paymentId}&s=${this.querySecret}`
          );
          this.setStepperPage("pageOne");
        },
        customClass: {
          title: "alertTitleClass",
        },
      });
    },
    activateTimerEvent(key) {
      setTimeout(() => {
        if (this.$refs[key]) this.$refs[key].activeInterval();
      }, 1);
    },
    deactivateTimerEvent(key) {
      setTimeout(() => {
        if (this.$refs[key]) this.$refs[key].clearInterval();
      }, 1);
    },
  },
  created() {
    this.setIsCompName("tether");
    this.setStepperPage("pageOne");
    this.paymentId = this.$route.query.id;
    this.querySecret = this.$route.query.s;
    if (!this.paymentId) {
      alertHelper.paymentIdNotValidAlert();
    }
  },
  destroyed() {
    this.deactivateTimerEvent("TetherTimer");
  },
};
